<div class="get-in-touch" id="get-in-touch">
  <div class="container">
    <span class="badge-pill">{{ 'get_in_touch.badge' | translate }}</span>
    <h2 class="section-heading">{{ 'get_in_touch.heading' | translate }}</h2>
    <p class="section-subheading">{{ 'get_in_touch.subheading' | translate }}</p>

    <form class="contact-form" [formGroup]="form" (ngSubmit)="onSubmit()">
      <div class="row g-3">
        <div class="col-12 col-md-6">
          <input type="text" class="form-control" formControlName="name" [attr.aria-label]="'get_in_touch.label_name' | translate" placeholder="{{ 'get_in_touch.label_name' | translate }}" />
        </div>
        <div class="col-12 col-md-6">
          <input type="email" class="form-control" formControlName="email" [attr.aria-label]="'get_in_touch.label_email' | translate" placeholder="{{ 'get_in_touch.label_email' | translate }}" />
        </div>
        <div class="col-12 col-md-6">
          <input type="tel" class="form-control" formControlName="phone" [attr.aria-label]="'get_in_touch.label_phone' | translate" placeholder="{{ 'get_in_touch.label_phone' | translate }}" />
        </div>
        <div class="col-12 col-md-6">
          <input type="text" class="form-control" formControlName="subject" [attr.aria-label]="'get_in_touch.label_subject' | translate" placeholder="{{ 'get_in_touch.label_subject' | translate }}" />
        </div>
        <div class="col-12">
          <textarea class="form-control" rows="5" formControlName="message" [attr.aria-label]="'get_in_touch.label_message' | translate" placeholder="{{ 'get_in_touch.label_message' | translate }}"></textarea>
        </div>
      </div>

      <button type="submit" class="btn btn-danger submit-btn">{{ 'get_in_touch.submit' | translate }}</button>
    </form>
  </div>
</div>